module.exports = __webpack_public_path__ + "img/924.152f0292.png";